import {
  REQUEST_MANIFEST,
  RECEIVE_MANIFEST,
  FAILED_MANIFEST
} from '../actions/manifest'

const initialState = {
  isFetching: false,
  items: []
}

export function gradelevels(state = initialState, action) {
  switch (action.type) {
    case REQUEST_MANIFEST: {
      return Object.assign({}, state, {
        isFetching: true,
        items: []
      })
    }
    case RECEIVE_MANIFEST: {
      const gradeLevels = Object.assign(
        {},
        action.payload.manifest.grade_levels
      )
      const gradeLevelsArray = []
      for (let i = 0; i < Object.keys(gradeLevels).length; i++) {
        gradeLevelsArray.push({
          id: parseInt(Object.keys(gradeLevels)[i]),
          name: Object.values(gradeLevels)[i].name,
          sort: Object.values(gradeLevels)[i].sort_order,
          available_for_activity_courses: Object.values(gradeLevels)[i].available_for_activity_courses,
          abbreviation: Object.values(gradeLevels)[i].abbreviation
        })
      }
      return Object.assign({}, state, {
        items: gradeLevelsArray,
        isFetching: false
      })
    }
    case FAILED_MANIFEST: {
      return Object.assign({}, state, {
        isFetching: false,
        items: []
      })
    }
    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/gradelevels.js